import { render, staticRenderFns } from "./PublicationDetailModal.vue?vue&type=template&id=22dfafcb&scoped=true&"
import script from "./PublicationDetailModal.vue?vue&type=script&lang=ts&"
export * from "./PublicationDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./PublicationDetailModal.vue?vue&type=style&index=0&id=22dfafcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dfafcb",
  null
  
)

export default component.exports